import config from './config.json'

export default config

//"PORTAL_TYPE": "ADMIN" , "VOTER"
